<template>

<v-data-table
               
               hide-default-footer
                :headers="headers"
                :items="data"
                text>
            </v-data-table>

</template>

<script>
export default {
props : {
    data : Array,
    headers : Array,
},
data(){
    return{
        pagination: {
             sortBy: 'type'
            },
    }
}
}

</script>